module.exports = __webpack_public_path__ + "img/duvdevan_yes.63f30c29.png";